export default __webpack_public_path__ + "static/media/bim.9f6be315.svg";